/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import { useEffect } from "react";

import {
	ICountryBrandApplicationContext,
	useCountryBrandApplicationContext,
} from "../../contexts/CountryBrandApplicationContextProvider";
import { UIEvents } from "../../UIEvents";

function ApplicantCompanyInformationStep() {
	const { currentStep, formRef, countryBrandApplication, update, setPreviousStep } =
		useCountryBrandApplicationContext() as ICountryBrandApplicationContext;

	const {
		applicantCompanyBusinessName,
		applicantCompanyName,
		applicantCompanyId,
		applicantCompanyAddress,
		applicantCompanyDepartment,
		applicantCompanyLocation,
		applicantCompanyPhone,
		applicantCompanyWeb,
		applicantCompanyEmail,
		applicantCompanyFacebook,
		applicantCompanyInstagram,
		applicantCompanyLinkedIn,
		applicantCompanyTwiter,
	} = countryBrandApplication;

	useEffect(() => {
		setPreviousStep(currentStep - 1);
		function submitStepData() {
			const formElement = formRef.current as HTMLFormElement;
			const applicantCompanyBusinessName = formElement.elements.applicantCompanyBusinessName.value;
			const applicantCompanyName = formElement.elements.applicantCompanyName.value;
			const applicantCompanyId = formElement.elements.applicantCompanyId.value;
			const applicantCompanyAddress = formElement.elements.applicantCompanyAddress.value;
			const applicantCompanyDepartment = formElement.elements.applicantCompanyDepartment.value;
			const applicantCompanyLocation = formElement.elements.applicantCompanyLocation.value;
			const applicantCompanyPhone = formElement.elements.applicantCompanyPhone.value;
			const applicantCompanyWeb = formElement.elements.applicantCompanyWeb.value;
			const applicantCompanyEmail = formElement.elements.applicantCompanyEmail.value;
			const applicantCompanyFacebook = formElement.elements.applicantCompanyFacebook.value;
			const applicantCompanyInstagram = formElement.elements.applicantCompanyInstagram.value;
			const applicantCompanyLinkedIn = formElement.elements.applicantCompanyLinkedIn.value;
			const applicantCompanyTwiter = formElement.elements.applicantCompanyTwiter.value;

			update({
				data: {
					applicantCompanyBusinessName,
					applicantCompanyName,
					applicantCompanyId,
					applicantCompanyAddress,
					applicantCompanyDepartment,
					applicantCompanyLocation,
					applicantCompanyPhone,
					applicantCompanyWeb,
					applicantCompanyEmail,
					applicantCompanyFacebook,
					applicantCompanyInstagram,
					applicantCompanyLinkedIn,
					applicantCompanyTwiter,
				},
				nextStep: currentStep + 1,
			});
		}

		document.addEventListener(UIEvents.builtInFormValidateSucess, submitStepData);

		return () => {
			document.removeEventListener(UIEvents.builtInFormValidateSucess, submitStepData);
		};
	}, []);

	return (
		<div className="step-page" id="step-2">
			<section>
				<h3>2 - Datos de la empresa solicitante</h3>
				<label htmlFor="applicantCompanyBusinessName">
					<p>Razón social *</p>
					<input
						type="text"
						name="applicantCompanyBusinessName"
						id="applicantCompanyBusinessName"
						required
						defaultValue={applicantCompanyBusinessName}
					/>
				</label>
				<label htmlFor="applicantCompanyName">
					<p>Nombre comercial *</p>
					<input
						type="text"
						name="applicantCompanyName"
						id="applicantCompanyName"
						required
						defaultValue={applicantCompanyName}
					/>
				</label>
				<label htmlFor="applicantCompanyId">
					<p>RUT *</p>
					<input
						type="text"
						name="applicantCompanyId"
						id="applicantCompanyId"
						required
						maxLength={12}
						minLength={12}
						defaultValue={applicantCompanyId}
					/>
				</label>
				<label htmlFor="applicantCompanyAddress">
					<p>Dirección *</p>
					<input
						type="text"
						name="applicantCompanyAddress"
						id="applicantCompanyAddress"
						required
						defaultValue={applicantCompanyAddress}
					/>
				</label>
				<label htmlFor="applicantCompanyDepartment">
					<p>Departamento *</p>
					<select
						name="applicantCompanyDepartment"
						id="applicantCompanyDepartment"
						defaultValue={applicantCompanyDepartment}
						placeholder={applicantCompanyDepartment}
					>
						<option value="Artigas">Artigas</option>
						<option value="Canelones">Canelones</option>
						<option value="Cerro Largo">Cerro Largo</option>
						<option value="Colonia">Colonia</option>
						<option value="Durazno">Durazno</option>
						<option value="Flores">Flores</option>
						<option value="Florida">Florida</option>
						<option value="Lavalleja">Lavalleja</option>
						<option value="Maldonado">Maldonado</option>
						<option value="Montevideo">Montevideo</option>
						<option value="Paysandú">Paysandú</option>
						<option value="Río Negro">Río Negro</option>
						<option value="Rivera">Rivera</option>
						<option value="Rocha">Rocha</option>
						<option value="Salto">Salto</option>
						<option value="San José">San José</option>
						<option value="Soriano">Soriano</option>
						<option value="Tacuarembó">Tacuarembó</option>
						<option value="Treinta y Tres">Treinta y Tres</option>
					</select>
				</label>
				<label htmlFor="applicantCompanyLocation">
					<p>Localidad *</p>
					<input
						type="text"
						name="applicantCompanyLocation"
						id="applicantCompanyLocation"
						required
						defaultValue={applicantCompanyLocation}
					/>
				</label>
				<label htmlFor="applicantCompanyPhone">
					<p>Teléfono *</p>
					<input
						type="tel"
						name="applicantCompanyPhone"
						id="applicantCompanyPhone"
						required
						pattern="[0-9]+"
						title="Solo debe contener números"
						defaultValue={applicantCompanyPhone}
					/>
				</label>
				<label htmlFor="applicantCompanyWeb">
					<p>Página web (Opcional)</p>
					<input
						type="text"
						name="applicantCompanyWeb"
						id="applicantCompanyWeb"
						defaultValue={applicantCompanyWeb}
					/>
				</label>
				<label htmlFor="contactPersonEmail">
					<p>Email *</p>
					<input
						type="email"
						name="applicantCompanyEmail"
						id="applicantCompanyEmail"
						required
						defaultValue={applicantCompanyEmail}
					/>
				</label>
				<label>
					<h4>Redes sociales (Si aplica)</h4>
				</label>
				<label htmlFor="facebook">
					<p>Facebook</p>
					<input
						type="text"
						name="applicantCompanyFacebook"
						id="applicantCompanyFacebook"
						defaultValue={applicantCompanyFacebook}
						placeholder="https://es-la.facebook.com/usuario/"
					/>
				</label>
				<label htmlFor="instagram">
					<p>Instagram</p>
					<input
						type="text"
						name="applicantCompanyInstagram"
						id="applicantCompanyInstagram"
						defaultValue={applicantCompanyInstagram}
						placeholder="https://www.instagram.com/usuario/"
					/>
				</label>
				<label htmlFor="linkedin">
					<p>LinkedIn</p>
					<input
						type="text"
						name="applicantCompanyLinkedIn"
						id="applicantCompanyLinkedIn"
						defaultValue={applicantCompanyLinkedIn}
						placeholder="https://www.linkedin.com/in/usuario/"
					/>
				</label>
				<label htmlFor="twiter">
					<p>Twitter</p>
					<input
						type="text"
						name="applicantCompanyTwiter"
						id="applicantCompanyTwiter"
						defaultValue={applicantCompanyTwiter}
						placeholder="https://twitter.com/usuario"
					/>
				</label>
			</section>
		</div>
	);
}

export { ApplicantCompanyInformationStep };
